import React from 'react';
import Text from 'components/ui/text';
import PromoIcon from 'images/icons/promo-outline-black.svg?react-svg';

export default function QtyDiscount({
  product,
  renderIcon,
  className,
  text,
  textProps = {}
}) {
  const savings =
    (product.price - product.package_item_price) * product.package_qty;

  return (
    <Text success className={className} {...textProps}>
      <span className="inline-block promo-icon">
        {renderIcon ? renderIcon() : <PromoIcon />}
      </span>
      {text ? text : `Buy ${product.package_qty} Save $${savings.toFixed(2)}`}
    </Text>
  );
}
